if (!customElements.get('featured-collection-swipe')) {
  class FeaturedCollectionSwipe extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.products');
      this.prevButton = this.querySelector('.featured-collection__arrow--prev');
      this.nextButton = this.querySelector('.featured-collection__arrow--next');

      if (!this.scroller || !this.prevButton || !this.nextButton || this.bound) return;

      this.bound = true;
      this.onScroll = () => this.updateArrows();
      this.onPrev = () => this.scrollByStep(-1);
      this.onNext = () => this.scrollByStep(1);
      this.mobileQuery = window.matchMedia('(max-width: 767px)');
      this.onMediaChange = () => this.updateArrows();

      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
      this.prevButton.addEventListener('click', this.onPrev);
      this.nextButton.addEventListener('click', this.onNext);
      this.mobileQuery.addEventListener('change', this.onMediaChange);

      this.observer = new ResizeObserver(() => {
        this.positionArrows();
        this.updateArrows();
      });
      this.observer.observe(this.scroller);
      const image = this.imageTarget();
      if (image) this.observer.observe(image);

      this.positionArrows();
      this.updateArrows();
    }

    disconnectedCallback() {
      if (!this.bound) return;

      this.scroller.removeEventListener('scroll', this.onScroll);
      this.prevButton.removeEventListener('click', this.onPrev);
      this.nextButton.removeEventListener('click', this.onNext);
      this.mobileQuery.removeEventListener('change', this.onMediaChange);
      this.observer.disconnect();
      this.bound = false;
    }

    imageTarget() {
      return this.scroller.querySelector('.product-card--featured-image');
    }

    positionArrows() {
      const image = this.imageTarget();
      if (!image) return;

      const imageRect = image.getBoundingClientRect();
      const trackRect = this.getBoundingClientRect();
      const center = imageRect.top - trackRect.top + imageRect.height / 2;
      this.style.setProperty('--arrow-center', `${center}px`);
    }

    updateArrows() {
      if (!this.mobileQuery.matches) {
        this.setArrow(this.prevButton, false);
        this.setArrow(this.nextButton, false);
        if (this.scroller.scrollLeft !== 0) this.scroller.scrollLeft = 0;
        return;
      }

      const maxScroll = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
      const scrollLeft = this.scroller.scrollLeft;
      const canScroll = maxScroll > 4;

      this.setArrow(this.prevButton, canScroll && scrollLeft > 4);
      this.setArrow(this.nextButton, canScroll && scrollLeft < maxScroll - 4);
    }

    setArrow(button, visible) {
      button.hidden = !visible;
      button.disabled = !visible;
    }

    scrollByStep(direction) {
      const items = this.scroller.querySelectorAll('.columns');
      const item = items[0];
      if (!item) return;

      let step = item.getBoundingClientRect().width;
      if (items[1]) {
        const next = items[1].getBoundingClientRect().left - item.getBoundingClientRect().left;
        if (next > 0) step = next;
      }

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.scroller.scrollBy({
        left: direction * step,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }
  }

  customElements.define('featured-collection-swipe', FeaturedCollectionSwipe);
}
